import { Component, computed, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  imports: [MatTooltip],
  selector: 'avs-metric-cell',
  standalone: true,
  templateUrl: './metric-cell.component.html',
})
export class MetricCellComponent {
  value = input.required<number | null | undefined>();
  formatter = input<(value: number) => string>();
  zeroTooltip = input<string>();
  nullTooltip = input<string>();
  estimated = input<boolean | null | undefined>(null);

  protected readonly displayText = computed(() => {
    const value = this.value();

    if (value === null || value === undefined) {
      return '--';
    }

    if (value === 0) {
      return '0';
    }

    return (this.formatter() ?? String)(value);
  });

  protected readonly tooltip = computed(() => {
    const value = this.value();

    return value === null || value === undefined ? this.nullTooltip() : value === 0 ? this.zeroTooltip() : undefined;
  });

  protected readonly showEstimatedBadge = computed(
    () => this.value() !== null && this.value() !== undefined && this.value() !== 0 && this.estimated() === true,
  );
}
